// Pure helpers for the time-counter model. No React, no IO; trivially testable.

// Cap on dt between polls. dt below this counts as playback (covers up to ~5x
// speed); dt above is treated as a seek and discarded. The user explicitly
// asked us NOT to penalise scrubbing — a seek doesn't burn time, but it
// also doesn't earn time. They have to actually watch.
export const ANTI_SKIP_DT = 5;

export function effectiveDuration(
  durationSecs: number,
  threshold: number
): number {
  if (!durationSecs || durationSecs <= 0) return 0;
  return durationSecs * threshold;
}

export function isComplete(
  secondsWatched: number,
  durationSecs: number,
  threshold: number
): boolean {
  const target = effectiveDuration(durationSecs, threshold);
  if (target <= 0) return false;
  return secondsWatched >= target;
}

export function remainingSecs(
  secondsWatched: number,
  durationSecs: number,
  threshold: number
): number {
  const target = effectiveDuration(durationSecs, threshold);
  return Math.max(0, target - secondsWatched);
}

export function creditTime(prevTime: number, currentTime: number): number {
  if (!Number.isFinite(currentTime) || currentTime < 0) return 0;
  if (prevTime < 0) return 0;
  const dt = currentTime - prevTime;
  if (dt <= 0 || dt >= ANTI_SKIP_DT) return 0;
  return dt;
}

export function formatMinSec(secs: number): string {
  const total = Math.max(0, Math.ceil(secs));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}
